import { render } from "./categoryInput.vue?vue&type=template&id=5bf59181"
import script from "./categoryInput.vue?vue&type=script&lang=js"
export * from "./categoryInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__